import { gql } from '@apollo/client';

export const UPDATE_CHARGE_IN_ARREST_ALL_FIELDS = gql`
  mutation addOrUpdateChargeInArrest($input: AddOrUpdateChargeInArrestInput!) {
    addOrUpdateChargeInArrest(input: $input) {
      clientMutationId
      errors
      incidentArrestUuid
      arrestChargeUuid
      arrestCharge {
        id
        nibrsSelected
        offenseViolationPrototype {
          code
          fullName
          id
          maxPenalty
          minPenalty
          name
          oriId
          points
          position
          waiver
          yoe
          offenseCategory {
            id
            name
            oriId
            position
          }
          offenseSubCategory {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`